import Share from "../modules/share";

export default {
  init() {
    Share.init();
  },
};
